import { TitleBar } from 'adminConsole/layout'
import { EditForm } from '..'
import { useParams } from 'react-router'

export const EditPage = () => {
  const { id = '' } = useParams<{ id: string }>()
  const title = id === '0' ? '新增參數' : '編輯參數'
  const isAddMode = id === '0'

  return (
    <>
      <TitleBar title={title} isLoading={false} />
      <EditForm isAddMode={isAddMode} id={Number(id)} />
    </>
  )
}
